import APISources from "../sources"
import instance from "../utils/axios";


export const getCalendarDataAsync = async (data, dispatch) => await instance.post(`${APISources().Calendar.ListURI}`, data, { signal: data?.signal, cancelToken: data?.cancelToken })
export const getMonthDataAsync = async (data,dispatch) => await instance.post(`${APISources().Calendar.MonthListURI}`,data,{signal: data?.signal,cancelToken: data?.cancelToken})
export const getWeekDataAsync = async(data,dispatch) => await instance.post(`${APISources().Calendar.WeekListURI}`,data,{signal: data?.signal,cancelToken: data?.cancelToken})